import { ReactNode } from "react";
import "./case-block-title.sass";

type Props = {
  children: ReactNode;
  color?: "blue" | "pink";
};

const CaseBlockTitle = ({ children, color = "blue" }: Props) => {
  return (
    <div className={`case-block-title case-block-title__${color}`}>
      {children}
    </div>
  );
};

export default CaseBlockTitle;
